import styled from "@emotion/styled"
import { forwardRef } from "react"

const IconWrapper = styled.div<{ isOpen: boolean; size: number }>`
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  background-color: transparent;
  filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.4));
  transition: all 0.3s ease;
  cursor: pointer;

  svg {
    width: 100%;
    height: 100%;
  }

  .background {
    transition: fill 0.2s ease;
  }

  .close-x {
    fill: #fff;
  }

  .open-background {
    fill: #ed7044;
  }

  &:hover {
    .open-background {
      fill: #c8320c;
    }
  }

  .close-background {
    fill: #03004e;
  }

  &:hover {
    .close-background {
      fill: #3b396f;
    }
  }

  .open-bubble {
    fill: #fff;
    stroke: #03004e;
    stroke-width: 2;
  }

  .open-question {
    fill: #03004e;
  }
`

const CloseIcon = ({ size }: { size: number }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 56 56"
  >
    <g transform="translate(-123 -156)">
      <g transform="translate(9547 -3084)">
        <rect
          width={size}
          height={size}
          rx="10"
          transform="translate(-9424 3240)"
          className="background close-background"
        />
      </g>
      <path
        d="M11.475-14.085H2.385V-4.77h-4.77v-9.315h-9.09v-4.32h9.09V-27.72h4.77v9.315h9.09Z"
        transform="translate(140.039 194.96) rotate(45)"
        className="close-x"
      />
    </g>
  </svg>
)

const CloseButton = forwardRef<
  HTMLDivElement,
  {
    isOpen: boolean
    size?: number
    children?: React.ReactNode
  } & React.HTMLAttributes<HTMLDivElement>
>(function CloseButton({ isOpen, size = 56, children, ...props }, ref) {
  return (
    <IconWrapper isOpen={isOpen} size={size} {...props} ref={ref}>
      {children || <CloseIcon size={size} />}
    </IconWrapper>
  )
})

CloseButton.displayName = "CloseButton"

export default CloseButton
